<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  (validate)="onValidate($event)"
>
  <section [formGroup]="getControl('data')">
    <div class="container start-page">
      <h1 class="section-header">
        {{ "APPEAL_REQUEST_HEADER" | globalTranslate }}
      </h1>
      <hr />
      <div>
        @if (!multipleCase) {
        <p>
          <span class="label-section">{{
            "CASE_NUMBER" | globalTranslate
          }}</span>
          <span> {{ singleCaseNum }}</span>
        </p>
        } @if (multipleCase) {
        <nh-field
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'APPEAL_REQUEST_STATIC_TEST1' | globalTranslate }}"
          class="label-section"
        >
          <div class="row">
            <div class="p-2">
              <select
                style="width: 340px; height: 38px"
                nhTranslate
                name="appealCaseNumber"
                [items]="caseNumberList"
                [attr.aria-label]="
                  'APPEAL_REQUEST_STATIC_TEST1' | globalTranslate
                "
                formControlName="appealCaseNumber"
                (change)="appealCaseFor()"
              ></select>
            </div>
            <div class="p-2"></div>
            <div class="p-2">
              <button
                id="showSelectAppelants"
                (click)="showSelectAppelants()"
                class="btn btn-secondary btn-search"
                [disabled]="!enableSearch"
              >
                {{ searchSelect | globalTranslate }}
              </button>
            </div>
          </div>
        </nh-field>
        }
      </div>
      @if (showSelectAppelantsTable) {
      <div>
        <h2 class="section-header">
          {{ "SELECT_APPELANTS_HEADER" | globalTranslate }}
        </h2>
        <hr />
        @if (isKepro) {
        <nh-field
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'APPEAL_REQUEST_STATIC_TEST11' | globalTranslate }}"
          class="label-section"
        >
          <nh-name-address
            [personalName]="getControl('data.callerName')"
            [isAssistingPerson]="false"
            [tables]="tables"
          >
          </nh-name-address>
        </nh-field>
        }
        <nh-field
          [attr.aria-required]="true"
          [mandatory]="true"
          label="{{ 'APPEAL_REQUEST_STATIC_TEST2' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="filingCaseFor"
            [items]="tableCodeValue('FILINGFOR', 'data.filingCaseFor')"
            [attr.aria-label]="'APPEAL_REQUEST_STATIC_TEST2' | globalTranslate"
            (change)="filingCaseFor()"
            [attr.disabled]="disableFlingCaseFor"
            formControlName="filingCaseFor"
          ></select>
        </nh-field>
        @if (enableTable) {
        <div class="d-none d-lg-block">
          @if (showKBELigibleMessage === true) {
          <p [innerHTML]="'APPEAL_REQUEST_KB_MESSAGE' | globalTranslate"></p>
          }
          <!-- globalTranslate -->
          <ngx-datatable
            class="bootstrap striped"
            #table
            [rows]="selectAppelantsRows"
            columnMode="force"
            [headerHeight]="'auto'"
            [footerHeight]="50"
            [rowHeight]="'auto'"
          >
            @for (col of selectAppelantsColumns; track col) {
            <ngx-datatable-column
              [cellClass]="'my-auto'"
              [name]="col.name | globalTranslate"
              [prop]="col.prop"
            >
            </ngx-datatable-column>
            }
            <ngx-datatable-column
              [cellClass]="'my-auto'"
              [name]="IncludeinGroupAppeal | globalTranslate"
            >
              <ng-template
                ngx-datatable-cell-template
                let-row="row"
                let-rowIndex="rowIndex"
              >
                <input
                  type="checkbox"
                  [checked]="row.groupAppelant"
                  attr.aria-label="checkbox{{ rowIndex }}"
                  (change)="
                    selectCheckBox(
                      $event,
                      row,
                      rowIndex,
                      'groupAppealSelect',
                      'browserView'
                    )
                  "
                  [value]="row.groupAppelant"
                  [disabled]="!row.enableGroupAppealCheckBox"
                />
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              [cellClass]="'my-auto'"
              [name]="PrimaryAppellant | globalTranslate"
            >
              <ng-template
                ngx-datatable-cell-template
                let-row="row"
                let-rowIndex="rowIndex"
              >
                <input
                  type="radio"
                  [checked]="row.primaryAppelant"
                  attr.aria-label="radiobutton{{ rowIndex }}"
                  (change)="
                    selectCheckBox(
                      $event,
                      row,
                      rowIndex,
                      'primaryAppealSelect',
                      'browserView'
                    )
                  "
                  [value]="row.primaryAppelant"
                />
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
          <nh-alert type="danger" [isOpen]="showPrimaryAlertMessage">
            <div class="row">
              <div class="col-auto icon">
                <img
                  src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
                  alt=""
                />
              </div>
              <div class="col message">
                <span>{{
                  "PRIMARY_APPELANT_VALIDATION_MESSAGE" | globalTranslate
                }}</span>
              </div>
            </div>
          </nh-alert>
        </div>
        } @if (enableTable) {
        <div class="nh-table-mobile d-lg-none">
          @for (row of selectAppelantsRows; track row; let rowIndex = $index) {
          <div class="table-row mb-3 pb-3">
            <div class="mobile-table-header">
              {{ selectAppelantsColumns[0].name | globalTranslate }}
            </div>
            <hr />
            <div class="mobile-table-data">{{ row.memberName }}</div>
            <br />
            <div class="mobile-table-header">
              {{ IncludeinGroupAppeal | globalTranslate }}
            </div>
            <hr />
            <button
              id="viewMyAppealLetters"
              (click)="
                selectCheckBox(
                  $event,
                  row,
                  rowIndex,
                  'groupAppealSelect',
                  'mobileView'
                )
              "
              class="btn btn-secondary btn-search"
              [disabled]="!row.enableGroupAppeal"
            >
              {{ row.groupAppealSelect | globalTranslate }}
            </button>
            <br /><br />
            <div class="mobile-table-header">
              {{ PrimaryAppellant | globalTranslate }}
            </div>
            <hr />
            <button
              id="viewMyAppealLetters"
              (click)="
                selectCheckBox(
                  $event,
                  row,
                  rowIndex,
                  'primaryAppealSelect',
                  'mobileView'
                )
              "
              class="btn btn-secondary btn-search"
              [disabled]="!row.enablePrimaryAppeal"
            >
              {{ row.primaryAppealSelect | globalTranslate }}
            </button>
            <br />
          </div>
          } @if (showKBELigibleMessage === true) {
          <p [innerHTML]="'APPEAL_REQUEST_KB_MESSAGE' | globalTranslate"></p>
          }
          <nh-alert type="danger" [isOpen]="showPrimaryAlertMessage">
            <div class="row">
              <div class="col-auto icon">
                <img
                  src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
                  alt=""
                />
              </div>
              <div class="col message">
                <span>{{
                  "PRIMARY_APPELANT_VALIDATION_MESSAGE" | globalTranslate
                }}</span>
              </div>
            </div>
          </nh-alert>
        </div>
        }
      </div>
      } @if (showSelectAppelantsTable && !showPrimaryAlertMessage) {
      <div>
        <h2 class="section-header">
          {{ "APPEAL_INFORMATION_HEADER" | globalTranslate }}
        </h2>
        <hr />
        <div class="ps-1 pt-1 hover-red">
          <a
            class="btn btn-link hover-red"
            tabindex="0"
            (click)="openAppealEligibilityModal()"
          >
            <span class="pe-2">{{ "TYPES_OF_APPEALS" | globalTranslate }}</span>
            <span><i class="fa fa-external-link" aria-hidden="true"></i></span>
          </a>
        </div>
        <br />
        <nh-field
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'APPEAL_REQUEST_STATIC_TEST3' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="appealEligibilityDecision"
            [items]="tableCodeValue('YESNO', 'data.appealEligibilityDecision')"
            [attr.aria-label]="'APPEAL_REQUEST_STATIC_TEST3' | globalTranslate"
            formControlName="appealEligibilityDecision"
            (change)="eligibilityDecision()"
            aria-required="true"
          ></select>
        </nh-field>
        @if ((isN('data.appealEligibilityDecision'))) {
        <p class="text-font">
          {{ "APPEAL_REQUEST_STATIC_TEST4" | globalTranslate
          }}<span style="color: #174a7c"><strong>1-800-878-3192</strong></span
          >{{ "APPEAL_REQUEST_STATIC_TEST5" | globalTranslate }}
        </p>
        } @if ((isY('data.appealEligibilityDecision'))) {
        <nh-field
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'APPEAL_REQUEST_STATIC_TEST6' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="renewalLetter"
            [items]="tableCodeValue('YESNO', 'data.renewalLetter')"
            [attr.aria-label]="'APPEAL_REQUEST_STATIC_TEST6' | globalTranslate"
            formControlName="renewalLetter"
            (change)="renewalLetter()"
            aria-required="true"
          ></select>
        </nh-field>
        } @if ((isN('data.renewalLetter'))) {
        <nh-field
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'APPEAL_REQUEST_STATIC_TEST10' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="ltssProgram"
            [items]="tableCodeValue('YESNO', 'data.ltssProgram')"
            [attr.aria-label]="'APPEAL_REQUEST_STATIC_TEST10' | globalTranslate"
            formControlName="ltssProgram"
            (change)="ltssChange()"
            aria-required="true"
          ></select>
        </nh-field>
        } @if (((isgroupAppeal || selectedSelf) && isN('data.ltssProgram') &&
        kbElgFlag)) {
        <nh-field
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'APPEAL_REQUEST_STATIC_TEST7' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="kBprogram"
            [items]="tableCodeValue('YESNO', 'data.kBprogram')"
            [attr.aria-label]="'APPEAL_REQUEST_STATIC_TEST7' | globalTranslate"
            formControlName="kBprogram"
            (change)="selcectKb()"
            aria-required="true"
          ></select>
        </nh-field>
        } @if (isY('data.renewalLetter')) {
        <nh-field
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'APPEAL_REQUEST_STATIC_TEST8' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="appealingReasonRenewal"
            [items]="
              tableCodeValue(
                'RENEWALAPPEALREASON',
                'data.appealingReasonRenewal'
              )
            "
            [attr.aria-label]="'APPEAL_REQUEST_STATIC_TEST8' | globalTranslate"
            formControlName="appealingReasonRenewal"
            (change)="appealReason('data.appealingReasonRenewal')"
            aria-required="true"
          ></select>
        </nh-field>
        } @if (isY('data.kBprogram') && (isgroupAppeal || selectedSelf)) {
        <nh-field
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'APPEAL_REQUEST_STATIC_TEST8' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="appealingReasonKb"
            [items]="
              tableCodeValue(
                'KATIEBECKETAPPEALREASON',
                'data.appealingReasonKb'
              )
            "
            [attr.aria-label]="'APPEAL_REQUEST_STATIC_TEST8' | globalTranslate"
            formControlName="appealingReasonKb"
            (change)="appealReason('data.appealingReasonKb')"
            aria-required="true"
          ></select>
        </nh-field>
        } @if (((!isgroupAppeal || !selectedSelf) && isN('data.renewalLetter')
        && isN('data.ltssProgram') && !isY('data.kBprogram')) || ((isgroupAppeal
        || selectedSelf) && isN('data.kBprogram') && kbElgFlag) ||
        ((isgroupAppeal || selectedSelf) && isN('data.ltssProgram') &&
        !kbElgFlag)) {
        <nh-field
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'APPEAL_REQUEST_STATIC_TEST8' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="appealingReasonElg"
            [items]="
              tableCodeValue(
                'ELIGIBLITYAPPEALREASON',
                'data.appealingReasonElg'
              )
            "
            [attr.aria-label]="'APPEAL_REQUEST_STATIC_TEST8' | globalTranslate"
            formControlName="appealingReasonElg"
            (change)="appealReason('data.appealingReasonElg')"
            aria-required="true"
          ></select>
        </nh-field>
        } @if (isY('data.ltssProgram')) {
        <nh-field
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'APPEAL_REQUEST_STATIC_TEST8' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="appealingReasonLtss"
            [items]="
              tableCodeValue('LTSSAPPEALREASON', 'data.appealingReasonLtss')
            "
            [attr.aria-label]="'APPEAL_REQUEST_STATIC_TEST8' | globalTranslate"
            formControlName="appealingReasonLtss"
            (change)="appealReason('data.appealingReasonLtss')"
            aria-required="true"
          ></select>
        </nh-field>
        } @if (duplicateAppealQuestionFlag &&
        isY('data.appealEligibilityDecision')) {
        <nh-field
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'APPEAL_REQUEST_STATIC_TEST9' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="duplicateAppeal"
            [items]="tableCodeValue('YESNO', 'data.duplicateAppeal')"
            [attr.aria-label]="'APPEAL_REQUEST_STATIC_TEST9' | globalTranslate"
            formControlName="duplicateAppeal"
            (change)="duplicateAppealDecision()"
            aria-required="true"
          ></select>
        </nh-field>
        }
      </div>
      }
    </div>
  </section>
</nh-form>